// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".speaker-card-header{padding:0;align-items:center;flex-direction:column;width:100%;border-bottom:0}.text-cap{color:#999}.card-img{border:2px solid #f4f5fa}.speaker-dialog{padding:10px!important;z-index:1080}", ""]);
// Exports
module.exports = exports;
